'use client'

import { Map, YMaps } from '@pbe/react-yandex-maps'

import { useProduct } from '@/screens/Product/hooks/useProduct'

import { MapMarker } from '@/features/product/choose-pickup-point/assets/MapMarker'

import { useGetDiscountProductStoresQuery } from '@/entities/catalog-discount'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { scrollToTabSection } from '@/shared/lib/utils/scroll/scrollToTabSection'
import { Button } from '@/shared/ui'

import panelCl from '../../ui/product-main/product-panel/product-panel.module.scss'

import { isDiscountProductBuy } from './is-discount-product-buy'

import cl from './discount-product-availability-widget.module.scss'

const TABS_ID_ATTR = `productTabs`
const MAP_TAB_PANE_ID = `tab-pane-map`
const PREVIEW_ZOOM = 15

const openStoresMapTab = (): void => {
	scrollToTabSection(TABS_ID_ATTR, MAP_TAB_PANE_ID)
}

export const DiscountProductAvailabilityWidget = (): JSX.Element | null => {
	const { product } = useProduct()
	const isProductBuy = isDiscountProductBuy(product.ORDER_TYPE)
	const { data: shops = [] } = useGetDiscountProductStoresQuery(String(product.ID ?? ``), {
		skip: !isProductBuy || product.ID == null
	})

	const shop = shops[0]
	const lat = Number(shop?.GPS_N)
	const lon = Number(shop?.GPS_S)

	if (!isProductBuy || !shop || !Number.isFinite(lat) || !Number.isFinite(lon)) return null

	return (
		<section className={`${panelCl.section} ${cl.root}`}>
			<div className={cl.header}>
				<p className={cl.title}>Наличие в магазине</p>
				{!!shop.NAME && <p className={cl.shopName} dangerouslySetInnerHTML={createMarkup(shop.NAME)} />}
			</div>
			<div className={cl.preview} onClick={openStoresMapTab}>
				<div className={cl.mapLayer} aria-hidden>
					<YMaps>
						<Map
							className={cl.map}
							defaultState={{
								center: [lat, lon],
								zoom: PREVIEW_ZOOM,
								behaviors: [],
								controls: []
							}}
							options={{
								suppressMapOpenBlock: true,
								yandexMapDisablePoiInteractivity: true
							}}
						/>
					</YMaps>
				</div>
				<span className={cl.marker}>
					<MapMarker className={cl.markerIcon} />
				</span>
				<Button as="span" theme="outlined" size="M" className={cl.ctaBtn}>
					Смотреть на карте
				</Button>
			</div>
		</section>
	)
}
